var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}
(function quickShopFix(){
  var populateGallery = quickShop.populateGallery;
  quickShop.populateGallery = function(){
    var self = this;
    var ret = populateGallery.apply(self, arguments);
    
    $('.js-gallery-modal').imagesLoaded(function(){
      $('.js-gallery-modal').flickity('resize');
    });
    
    $('.js-gallery-carousel').imagesLoaded(function(){
      $('.js-gallery-carousel').flickity('resize');
    });


    return ret;
  }
})();

(function($){
  
  	var RADIO = '.swatch[data-option-index] :radio';
  
	function ImageChanger(){
		$(document).on('change', RADIO, $.proxy( this.onChange, this ) );
      	$(document).on('afterShow.fb', $.proxy( this.onOpenModal, this ) ); 
      	$($.proxy(this.ready, this));
	}
	$.extend( ImageChanger.prototype, {
      
      	ready : function(){
          	if( !$('.product_section .product_gallery').length ) {
             	return;
            }
	        $(RADIO+':checked').first().trigger('change');
      	},
      
		onChange : function(e){
//          	this.setup( e.target );
			this.update( e.target );
		},
      
        onOpenModal(){
          	setTimeout(function(){
                var checked = $('.js-quick-shop '+RADIO+':checked');
              	// clear this out...
              	$('.js-quick-shop .product_gallery').data('$images', null);
              	$('.js-quick-shop .product_gallery_nav').data('$thumbs', null);
                if( checked.length ){
                  	checked.first().trigger('change');
                }
            }, 10 );
        },

		update : function( el ){
          	var $container = $(el).closest('.js-quick-shop, .product_section');
          	var key = $(el).closest('.swatch').find('.option_title').text();
          	var $gallery = $container.find('.product_gallery');
            var state = {
              	$imageCarousel: $container.find('.product_gallery'),
              	$thumbCarousel: $container.find('.product_gallery_nav'),
              	imageCarousel : $container.find('.product_gallery').data().flickity,
	            thumbCarousel : $container.find('.product_gallery_nav').data().flickity
            };
          
            if( !$gallery.data('$images') ){
            	$gallery.data('$images', $container.find('.product_gallery .gallery-cell').each(function(i){
					$(this).attr('data-index', i);
                }).clone());
	            $gallery.data('$thumbs', $container.find('.product_gallery_nav .gallery-cell').each(function(i){
					$(this).attr('data-index', i);
                }).clone()); 
            }
            
          	state.$images = $gallery.data('$images');
          	state.$thumbs = $gallery.data('$thumbs');
          
			// get a map of all the chosen variants
			state.variants = this.getVariants( $container );
			this.updateImages( state, key );
          
		},
		
      	/**
         * Save the currently selected variants as an object property
         * that we can use as a lookup when going through the images
         * in the updateImages function
         */
		getVariants : function( $container ){
			var variants = {};
			$container.find('.swatch[data-option-index]').each(function(){
				var key = $(this).find('.option_title').text();
				var val = $(this).find('input[type=radio]:checked').val();
				variants[key] = {val: val, images: []};
			});
            
			return variants;
		},
      
      	/**
         * This function will go through each image and check its meta data
         * against the currently selected variants and hide/show as necessary.
         * If a variant key is not included in the meta, it is assumed to be
         * true.
         */
		updateImages : function( state, key ){
			var variants = state.variants;
			var images = [];
            var remove = [];
          
			state.$images.each(function( i, el ){
				var data = $(el).data('meta');
				$.each( variants, function(k, v){
					var val = v.val;
					var cur = data[k];
					if( !cur || cur === val || $.isArray(cur) && ~cur.indexOf(val) ){
						v.images.push( i );
                        if( cur && v.first === undefined ){
                          	v.first = i;
                        }
                      	if( cur ){
                          	if( !v.explicit ) v.explicit = [];
                          	v.explicit.push(i);
                        }
						if( data['default'] && data['default'] === k ){
							v.default = i;
						}
						if( !~images.indexOf(i) ) images.push(i);
					}
				});
			});
          
			$.each( variants, function(k, v){
				var remove = [];
				$.each(images, function(j, i){
					if( !~v.images.indexOf( i ) ){
						remove.push( i );
					}
				});
				$.each(remove, function(j, i){
					images.splice( images.indexOf( i ), 1 );
				});
			});
          
          
          	var seen = 0;
          	var map = {};
          
          	// clear out the old thumbs...
            while( state.imageCarousel.cells.length ){
				state.imageCarousel.remove(
                  state.imageCarousel.cells[0].element
                );
              	state.thumbCarousel.remove(
                  state.thumbCarousel.cells[0].element
                );
            }
          	
            state.$images.each( function(i){
              	var show = !!~images.indexOf(i);
                var visible = state.$imageCarousel.find('.gallery-cell[data-index="'+i+'"]').is(':visible');
              	if( show && visible ){
	            	seen++; 
                }
                else if( show && !visible ){
                    state.imageCarousel.append(state.$images.eq(i).clone());
                    state.thumbCarousel.append(state.$thumbs.eq(i).clone());
                    seen++;
                }
                else if( !show && visible ){
                  	state.imageCarousel.remove(state.$imageCarousel.find('.gallery-cell[data-index="'+i+'"]'));
	                state.thumbCarousel.remove(state.$thumbCarousel.find('.gallery-cell[data-index="'+i+'"]'));
                  
                }
                else if( !show && !visible ){
                  	// noop
                }
                if( show ){
					map[i] = seen-1;
                }
              	
            });
          
            state.imageCarousel.reloadCells();
          	state.thumbCarousel.reloadCells();
          
			var s = 0;

          	if( key && variants[key].explicit && variants[key].explicit.length ){
              var j = variants[key].explicit.find(function(i){
                if( map[i] !== undefined ){
                  return true;
                }
                return false;
              });
              if( j !== undefined) s = map[j];
            }
			
          	state.imageCarousel.select(s, true, true);
	        state.thumbCarousel.select(s, true, true);
          
	        state.$imageCarousel.imagesLoaded( function(){
               state.imageCarousel.resize();
            });
          	
          	state.$thumbCarousel.imagesLoaded( function(){
               state.thumbCarousel.resize();
            });
          	
		}
	});
	jQuery(function(){
		window.imageChanger = new ImageChanger();
	});
})(jQuery);